/* NOTES

We rewrite the Tailwind defaults to be .font-400 VS .font-normal
This is because "normal" and "bold" have different number values across different fonts.
For example, "400" in Freight is "Book" but in Neue Haas Unica it is "Regular".
Tailwind calls both of these "normal".
Setting things to numbers allows us to remove one layer of ambiguity.

| Weight | Tailwind   | Neue Haas Unica | Freight  | Alt Gothic | Used? |
| ------ | ---------- | --------------- | -------- | ---------- | ----- |
| 100    | thin       | Ultralight      | n/a      | Light      |       |
| 200    | extraLight | Thin            | n/a      | Semilight  |       |
| 300    | light      | Light           | Light    | Book       |       |
| 400    | normal     | Regular         | Book     | Regular    | Yes   |
| 500    | medium     | Medium          | Medium   | Medium     |       |
| 600    | semibold   | Bold            | Semibold | Demi       | Yes   |
| 700    | bold       | Heavy           | Bold     | Bold       |       |
| 800    | extrabold  | Black           |          | Heavy      | Yes   |
| 900    | black      | ExtraBlack      | Black    | Black      |       |

*/

export const WEIGHTS = {
  // We only enable the weights that are used
  '400': '400',
  '600': '600',
  '800': '800',

  // and reserve the rest for future use
  // '100': '100',
  // '200': '200',
  // '300': '300',
  // '500': '500',
  // '700': '700',
  // '900': '900',
};

type SizesType = {
  [key: string]: {
    lineHeight: string;
    weight: string;
    sizes: {
      [key: string]: {
        fontSize: number;
        lineHeightOverride?: string;
        weightOverride?: string;
      };
    };
  };
};

export const SIZES: SizesType = {
  display: {
    lineHeight: '1.27',
    weight: WEIGHTS[600],
    sizes: {
      '2200': {
        fontSize: 88,
        // weightOverride: WEIGHTS[800],
        // lineHeightOverride: '1.25',
      },
      '1800': {
        fontSize: 72,
      },
      '1400': {
        fontSize: 56,
      },
      '1000': {
        fontSize: 40,
      },
      '800': {
        fontSize: 32,
      },
      '600': {
        fontSize: 24,
      },
      '500': {
        fontSize: 20,
      },
    },
  },
  heading: {
    lineHeight: '1.25',
    weight: WEIGHTS[800],
    sizes: {
      '1600': {
        fontSize: 64,
      },
      '1300': {
        fontSize: 52,
      },
      '1000': {
        fontSize: 40,
      },
      '850': {
        fontSize: 34,
      },
      '600': {
        fontSize: 24,
        weightOverride: WEIGHTS[600],
      },
      '500': {
        fontSize: 20,
        weightOverride: WEIGHTS[600],
      },
      '400': {
        fontSize: 16,
        weightOverride: WEIGHTS[600],
      },
      '350': {
        fontSize: 14,
        weightOverride: WEIGHTS[600],
      },
    },
  },
  body: {
    lineHeight: '1.375',
    weight: WEIGHTS[400],
    sizes: {
      '550': {
        fontSize: 22,
      },
      '450': {
        fontSize: 18,
      },
      '400': {
        fontSize: 16,
      },
      '350': {
        fontSize: 14,
      },
      '300': {
        fontSize: 12,
      },
    },
  },
  tag: {
    lineHeight: '1.375',
    weight: WEIGHTS[600],
    sizes: {
      '350': {
        fontSize: 14,
      },
      '300': {
        fontSize: 12,
      },
    },
  },
  condensed: {
    lineHeight: '1.05',
    weight: WEIGHTS[800],
    sizes: {
      '1000': {
        fontSize: 40,
      },
      '750': {
        fontSize: 30,
      },
      '600': {
        fontSize: 24,
      },
    },
  },
};

export const TYPOGRAPHY = {
  WEIGHTS,
  SIZES,
};
